import { Table } from "../../features/Table";
import { type Country, country_columns } from "./columns";
import { FilterCountries } from "./filter";
import { useLocation } from "react-router-dom";

const client = "instit-quantilia";
const table_name = "countries";

export const CountriesTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;

  return (
    <Table<Country, Country>
      label="Countries"
      client={client}
      table_name={table_name}
      columns={country_columns}
      filter={<FilterCountries />}
      disable_translations_request={true}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
